import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseUrl = process.env.REACT_APP_BASE_URL;

export const supportApi = createApi({
  reducerPath: "supportApi",
  tagTypes: ["MyTickets", "MyTicket"],
  baseQuery: fetchBaseQuery({
    baseUrl,
    credentials: "include",
    headers: { "Content-Type": "application/json" },
  }),
  endpoints: (builder) => ({
    createTicket: builder.mutation({
      query: (body) => ({
        url: "support/tickets",
        method: "POST",
        body,
      }),
      invalidatesTags: ["MyTickets"],
    }),
    createCallback: builder.mutation({
      query: (body) => ({
        url: "support/callbacks",
        method: "POST",
        body,
      }),
      invalidatesTags: ["MyTickets"],
    }),
    getMyTickets: builder.query({
      query: ({ page = 1, limit = 20 } = {}) => ({
        url: "support/my-tickets",
        params: { page, limit },
      }),
      providesTags: ["MyTickets"],
    }),
    getMyTicketById: builder.query({
      query: (id) => `support/my-tickets/${id}`,
      providesTags: (_r, _e, id) => [{ type: "MyTicket", id }],
    }),
    replyToMyTicket: builder.mutation({
      query: ({ id, body }) => ({
        url: `support/my-tickets/${id}/messages`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_r, _e, { id }) => [
        "MyTickets",
        { type: "MyTicket", id },
      ],
    }),
    lookupTicket: builder.query({
      query: ({ referenceNumber, email }) => ({
        url: "support/tickets/lookup",
        params: { referenceNumber, email },
      }),
    }),
  }),
});

export const {
  useCreateTicketMutation,
  useCreateCallbackMutation,
  useGetMyTicketsQuery,
  useGetMyTicketByIdQuery,
  useReplyToMyTicketMutation,
  useLazyLookupTicketQuery,
} = supportApi;
